import { withCurrentParams } from 'actions/utils';
import { BROADCAST_STOP_RECORDING } from 'actions/Types';
import { BROADCAST_RECORDING_STOP } from 'store/eventConstants';

export default recordingId => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, _, socket) => {
      const action = {
        type: BROADCAST_STOP_RECORDING,
        request: async apiClient => {
          const response = await apiClient.broadcast.stopRecording(
            teamId,
            eventId,
            broadcastId,
            recordingId
          );

          // notify other directors
          socket.emit(BROADCAST_RECORDING_STOP, { broadcastId });

          return response;
        }
      };
      dispatch(action);
    }
  );
};
